"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getAPI = _interopRequireDefault(require("./getAPI"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var demoObject = {
  index: {
    id: 'index',
    name: 'index',
    pageUrl: 'index'
  }
};
var pagesNames = Object.values((0, _getAPI["default"])().pages || demoObject).reduce(function (prev, curr) {
  return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, curr.pageUrl, curr));
}, {});
var getPropsUrlPages = function getPropsUrlPages() {
  var _window, _window$location$hash;
  return (((_window = window) === null || _window === void 0 ? void 0 : (_window$location$hash = _window.location.hash) === null || _window$location$hash === void 0 ? void 0 : _window$location$hash.slice(2).split('/')) || ['index']).map(function (name, i) {
    return {
      title: i === 0 ? pagesNames.index.name : pagesNames[name].name,
      value: i === 0 ? pagesNames.index.id : pagesNames[name].id
    };
  });
};
var _default = getPropsUrlPages;
exports["default"] = _default;